<template>
  <div id="addon-vessel-report-export">
    <div class="vx-card p-6 vs-lg-10 vs-sm-12">
      <div class="algolia-header mb-4">
          <p class="font-semibold algolia-filters-label">
            集計期間
          </p>
      </div>
      <div class="flex-container">
        <div class="select-input">
          <v-select
            :clearable="false"
            v-model="selectedYear"
            :options="yearOptions"
            label="text"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          ></v-select>
        </div>
        <div class="select-input">
          <v-select
            :clearable="false"
            :value="selectedMonth"
            :options="monthOptions"
            v-model="selectedMonth"
            label="text"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          ></v-select>
        </div>
        <div>
          <vs-button color="primary" class="btn-download" type="filled" v-bind:disabled="selectedYear==null" v-on:click="executeExportReport">ダウンロード</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import vSelect from "vue-select";
const { mapActions } = createNamespacedHelpers("vesselReportExport");

export default {
  components: {
    vSelect
  },
  data() {
    return {
      currentDate: new Date(),
      selectedMonth: {
        text: "全て",
        value: null
      },
      selectedYear: {
        text: "2020年",
        value: 2020
      }
    };
  },

  computed: {
    // 未来の月を選択肢に入れない制御
    monthOptions() {
      let month = this.currentDate.getMonth() + 1
      let year = this.currentDate.getFullYear()
      let options = [{
        text: "全て",
        value: null
      }]
      if (this.selectedYear.value == year) {
        for (let i = 1; i <= month; i++) {
          options.push({
            text: `${i}月`,
            value: i
          })
        }
      } else {
        for (let i = 1; i <= 12; i++) {
          options.push({
            text: `${i}月`,
            value: i
          })
        }
      }
      return options
    },
    // 2020年から今年までを選択肢とする
    yearOptions() {
      const baseYear = 2020
      let options = []
      let year = this.currentDate.getFullYear()
      for (let i = baseYear; i <= year; i++) {
        options.push(
          {
            text: `${i}年`,
            value: i
          }
        )
      }
      return options
    }
  },

  watch: {
    selectedYear() {
      this.selectedMonth = {
        text: "全て",
        value: null
      }
    }
  },

  methods: {
    ...mapActions(["exportReport"]),
    async executeExportReport() {
      let payload = {
        year: this.selectedYear.value,
        month: this.selectedMonth.value
      };
      this.$vs.loading();
      try {
        let res = await this.exportReport(payload)
        let blob = res.data;
        const uri = URL.createObjectURL(blob)
        const link = document.createElement('a')
        const suffixYear = this.selectedYear.value + "年"
        const suffixMonth = this.selectedMonth.value ? this.selectedMonth.value + "月" : ""
        link.download = `船舶動静連絡${suffixYear}${suffixMonth}.zip`
        link.href = uri
        link.click()
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
  },
};
</script>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  justify-content: flex-start;
}

.select-input {
  width: 180px;
  margin-right: 20px;
}

#addon-vessel-report-export {
  .btn-download {
    padding: .4rem 2rem;
  }
}

</style>
